import ModalComponent from 'src/components/Modal/ModalComponent';
import { getOrderReviewWhatsappURL } from 'src/utils/whatsapp';

export const InvalidShippingCostModal = ({ closeModal, orderNumber }) => {
  const orderReviewWhatsappURL = getOrderReviewWhatsappURL(orderNumber);
  return (
    <ModalComponent title="Custo de envio inválido" closeModal={closeModal}>
      <p className="mb-2">
        Atenção: o valor preenchido é muito alto. Caso deseje seguir com este
        valor, entre em contato com nosso atendimento clicando no botão de
        WhatsApp.
      </p>
      <a
        target="_blank"
        className="btn btn-deny fw-normal border border-dark border-1"
        href={orderReviewWhatsappURL}
        rel="noreferrer noopener"
      >
        Fale conosco
      </a>
    </ModalComponent>
  );
};
